export class UberweiserOpenDialogModel {
    constructor(public title: string, public message: string) {
    }
}
